import React, { useState, useEffect } from "react";
import axios from "axios";
import { api_base_url } from "config";
import snoopyWelcome from "./images/snoopy-work.png"
import snoopyWorking from "./images/snoopy-wellcome.png"


const Dashboard = () => {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    cupons: 0,
    lojas: 0,
    categorias: 0,
    especiais: 0
  });

  useEffect(() => {
    if (localStorage.getItem("access_token") === null) {
      window.location.href = "/login";
    } else {
      (async () => {
        try {
          setLoading(true);
          const url = api_base_url + "/dashboard/";
          const { data } = await axios.get(url);
          setMessage(data.message);
          
          // Simular dados de estatísticas (substituir por chamadas API reais)
          setStats({
            cupons: 145,
            lojas: 37,
            categorias: 12,
            especiais: 8
          });
          
          setLoading(false);
        } catch (e) {
          console.error("not auth", e);
          setLoading(false);
        }
      })();
    }
  }, []);

  return (
    <div className="space-y-6">
      {/* Cabeçalho */}
      <div className="flex flex-col space-y-2">
        <h1 className="text-3xl font-bold tracking-tight">DASHBOARD</h1>
        <p className="text-muted-foreground">Bem vindo ao painel administrativo!</p>
      </div>

      {/* Saudação personalizada com tema Snoopy */}
      <div className="rounded-lg border bg-card p-6 shadow-sm">
        <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-4">
          <div className="flex-shrink-0 w-48 h-48 rounded-full overflow-hidden flex items-center justify-center bg-blue-100">
            {/* Aqui você pode adicionar uma imagem do Snoopy */}
            <img 
              src={snoopyWorking} 
              alt="Snoopy trabalhando" 
              className="h-32 w-auto"
            />
          </div>
          <div className="flex-1">
            <div className="relative">
              <div className="absolute -top-6 -left-6 w-12 h-12 bg-white rounded-full border-2 border-primary flex items-center justify-center">
                <span className="text-lg font-bold text-primary">!</span>
              </div>
              <div className="bg-white rounded-lg p-6 shadow-md border-2 border-primary">
                <h3 className="text-xl font-medium mb-2">
                  {loading ? "Carregando..." : `Olá ${message}!`}
                </h3>
                <p className="text-gray-600">
                  Bem-vindo ao seu painel de controle. Aqui você pode gerenciar todos os cupons, lojas e muito mais.
                </p>
                <p className="mt-4 text-sm italic text-gray-500">
                  "Na vida, existem coisas que você precisa fazer, mesmo quando ninguém te manda. Isso se chama iniciativa." - Snoopy
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Estatísticas */}
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        <div className="rounded-lg border bg-card p-6 shadow-sm hover:shadow-md transition-shadow">
          <div className="flex flex-row items-center justify-between space-y-0 pb-2">
            <h3 className="text-sm font-medium tracking-tight text-muted-foreground">Cupons Ativos</h3>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              className="h-4 w-4 text-muted-foreground"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </div>
          <div className="flex items-baseline gap-1">
            <h2 className="text-3xl font-bold">{stats.cupons}</h2>
            <p className="text-xs text-green-500">+12%</p>
          </div>
        </div>
        
        <div className="rounded-lg border bg-card p-6 shadow-sm hover:shadow-md transition-shadow">
          <div className="flex flex-row items-center justify-between space-y-0 pb-2">
            <h3 className="text-sm font-medium tracking-tight text-muted-foreground">Lojas</h3>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              className="h-4 w-4 text-muted-foreground"
            >
              <rect width="20" height="14" x="2" y="5" rx="2" />
              <path d="M2 10h20" />
            </svg>
          </div>
          <div className="flex items-baseline gap-1">
            <h2 className="text-3xl font-bold">{stats.lojas}</h2>
            <p className="text-xs text-green-500">+7%</p>
          </div>
        </div>
        
        <div className="rounded-lg border bg-card p-6 shadow-sm hover:shadow-md transition-shadow">
          <div className="flex flex-row items-center justify-between space-y-0 pb-2">
            <h3 className="text-sm font-medium tracking-tight text-muted-foreground">Categorias</h3>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              className="h-4 w-4 text-muted-foreground"
            >
              <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
            </svg>
          </div>
          <div className="flex items-baseline gap-1">
            <h2 className="text-3xl font-bold">{stats.categorias}</h2>
            <p className="text-xs text-muted-foreground">+0%</p>
          </div>
        </div>
        
        <div className="rounded-lg border bg-card p-6 shadow-sm hover:shadow-md transition-shadow">
          <div className="flex flex-row items-center justify-between space-y-0 pb-2">
            <h3 className="text-sm font-medium tracking-tight text-muted-foreground">Especiais</h3>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              className="h-4 w-4 text-muted-foreground"
            >
              <path d="m16 6 4 4-8 8-8-8 4-4" />
              <path d="m12 2 4 4-8 8-4-4" />
            </svg>
          </div>
          <div className="flex items-baseline gap-1">
            <h2 className="text-3xl font-bold">{stats.especiais}</h2>
            <p className="text-xs text-red-500">-2%</p>
          </div>
        </div>
      </div>

      {/* Seção Snoopy Inspiracional */}
      <div className="rounded-lg border bg-blue-50 p-6 shadow-sm">
        <div className="flex flex-col md:flex-row items-center gap-6">
          <div className="flex-shrink-0 hidden md:block">
          <img 
            src={snoopyWelcome} 
            alt="Snoopy" 
            className="h-full object-cover"
          />
          </div>
          <div>
            <h3 className="text-xl font-bold mb-2 text-blue-800">Dica do Snoopy</h3>
            <p className="text-blue-700">
              "Mantenha seus cupons atualizados e suas categorias organizadas. É assim que se constrói um excelente site de cupons de desconto!"
            </p>
            <div className="mt-4 flex gap-2">
              <button className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90">
                Ver Tutorial
              </button>
              <button className="inline-flex items-center justify-center rounded-md border border-input bg-background px-4 py-2 text-sm font-medium hover:bg-accent hover:text-accent-foreground">
                Relatar Problema
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;